


































































import { mapGetters, mapActions } from "vuex";
const click = require("@/audio/click.mp3");
import { ethers } from "ethers";
import SUPAFoundation from "@/contracts/SUPAFoundation.json";
import SUPACell from "@/contracts/SUPACell.json";
import SUPAVirus from "@/contracts/SUPAVirus.json";
import SUPAOrganism from "@/contracts/SUPAOrganism.json";

import addresses from "@/contracts/addresses.json";
export default {
  name: "SUPAOrganisms",
  computed: {
            ...mapGetters("controls", ["isPlaying"]),

  ...mapGetters("accounts", ["getChainData", "isUserConnected",  "getWeb3Provider","isInitialized",
      "isUserConnected",
      "getChainId","getAccountDetails","getActiveAccount"
])  },
   async created() {
     this.$store.dispatch("accounts/getIsLoggedIn");
       await this.connect();

    if (!this.getWeb3Provider) {
      //document.location.href = "/";
    } else {
      // get the contract instance
      let provider = new ethers.providers.Web3Provider(this.getWeb3Provider);
      let signer = provider.getSigner();
             const address = await signer.getAddress();

  const supaOrganismContractAddress = addresses.SUPAOrganism[parseInt(this.getChainId)];

       this.supaOrganismContract=new ethers.Contract(supaOrganismContractAddress, SUPAOrganism.abi, signer);

  const supaVirusContractAddress = addresses.SUPAVirus[parseInt(this.getChainId)];

       this.supaVirusContract=new ethers.Contract(supaVirusContractAddress, SUPAVirus.abi, signer);

  const supaCellContractAddress = addresses.SUPACell[parseInt(this.getChainId)];

       this.supaCellContract=new ethers.Contract(supaCellContractAddress, SUPACell.abi, signer);
    try {
         
         this.SUPAOrganismCount= await this.supaOrganismContract.balanceOf(address);
         for(let i=0;i<this.SUPAOrganismCount;i++){
            let tokenId=await  this.supaOrganismContract.tokenOfOwnerByIndex(address,i)
                                
          
            this.SUPAOrganismList.push({id:tokenId, img:"https://supafoundation.b-cdn.net/assets/images/SUPA_Organism.png",counter:i+1})
           

          }
        if(this.SUPAOrganismCount<4){
          for(let i=0;i<4-this.SUPAOrganismCount;i++){
          this.SUPAOrganismList.push({id:null,img:"https://supafoundation.b-cdn.net/assets/images/placeholder.png",counter:this.SUPAOrganismCount+i+1})

          }
        }
        if(this.SUPAOrganismCount==0){
          console.log("here")
            for(let i=0;i<4;i++){
          this.placeHolder.push({img:"https://supafoundation.b-cdn.net/assets/images/placeholder.png",counter:i+1})

          }
        }

      } catch (err) {
        this.$toasted.global.app_error();
        console.log(err);
      }

    
    }
  },
  methods:{
      goBack() {
     this.$router.push('/main')
    },
            ...mapActions("accounts", ["connect"]),
viewOrganism(id){
  this.$router.push('/supaorganism/'+id)
},
playmusic(){
   this.$store.dispatch("controls/playMusic",{toPlay:true});


},
pausemusic(){
   this.$store.dispatch("controls/playMusic",{toPlay:false});


},
 playclick(){
      this.audioclick.volume=0.3;
      this.audioclick.play();
    },
  },
   data() {
    return {
        audioclick:new Audio(click),
      playMusic:false,
      SUPAOrganismCount:0,
      SUPACellCount:0,
      SUPAVirusCount:0,
      SUPAOrganismList:[],
      placeHolder:[],   

    };
  },
};
